import { useCallback, useState } from "react";
import { ORDER, SORTING } from "./constants";

export interface PartnerTableSortingAction {
  type?: string;
}

export interface PartnerTableSortingHook {
  sorting: string;
  order: string;
  onAction: (action?: PartnerTableSortingAction) => void;
}

export default function usePartnerTableSorting(): PartnerTableSortingHook {
  const [sorting, setSorting] = useState(SORTING.UPDATED_AT);
  const [order, setOrder] = useState(ORDER.NORMAL);

  const onAction = useCallback(
    (action: PartnerTableSortingAction = {}) => {
      const { type } = action;

      if (type === "id-alphabetical") {
        if (sorting !== SORTING.ID) {
          setSorting(SORTING.ID);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      setSorting(SORTING.UPDATED_AT);
      setOrder(ORDER.NORMAL);
    },
    [order, sorting]
  );

  return {
    sorting,
    order,
    onAction,
  };
}
